module.exports = __webpack_public_path__ + "img/web-monitor.3038cff2.svg";